import { FC, ReactNode } from 'react'
import { formatDateTime } from '../../../../../_metronic/helpers'
import { useT } from '../../../../../_metronic/i18n/Metronici18n'
import { ConteudoNotaVersao } from './ConteudoNotaVersao'

type Props = {
  versao: string
  dtPublicacao?: string
  conteudo: string
  /** Fora do modal (histórico, pré-visualização) o título vem no corpo; no modal, no cabeçalho. */
  titulo?: string
  /** Selo ao lado da versão (ex.: "Lida"). */
  selo?: ReactNode
}

/** Layout da nota igual no modal, no histórico e na pré-visualização do admin. */
export const NotaVersaoCorpo: FC<Props> = ({ versao, dtPublicacao, conteudo, titulo, selo }) => {
  const { t } = useT()

  return (
    <div className='d-flex flex-column gap-3'>
      {titulo && <h2 className='fs-3 fw-bold text-gray-900 mb-0'>{titulo}</h2>}
      <div className='d-flex flex-wrap align-items-center gap-2 fs-7 text-gray-700'>
        <span className='fw-semibold'>{t('notas_versao.versao_x', { versao })}</span>
        <span aria-hidden='true'>·</span>
        <span>{t('notas_versao.publicada_em', { data: formatDateTime(dtPublicacao) })}</span>
        {selo}
      </div>
      <ConteudoNotaVersao conteudo={conteudo} ariaLabel={t('notas_versao.conteudo_aria')} />
    </div>
  )
}
